/* eslint-disable */
import "../App.css";

import React, { useState, useEffect, useRef } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Navbar from "react-bootstrap/Navbar";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import Image from "react-bootstrap/Image";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../assets/images/Motivar.svg";
import Image_help from "../assets/images/image_help.png";
import SuccessTick from "../assets/images/successTick.png";
import AppFooter from "../components/Footer.js";
import { toast } from "react-hot-toast";
import GeneralDataServices from "../Services/GeneralDataServices.js";
import axiosInstance from "../utils/axiosInstance";
import {
  FiArrowLeft, FiBookOpen, FiDollarSign, FiClock,
  FiLock, FiGlobe, FiUserCheck, FiPlus, FiTrash2,
  FiCheckCircle, FiShield, FiHelpCircle, FiSend, FiStar
} from "react-icons/fi";

const PLATFORM_OPTIONS = [
  'Coursera',
  'Udemy',
  'edX',
  'Udacity',
  'Pluralsight',
  'LinkedIn Learning',
  'Skillshare',
  'DataCamp',
  'Codecademy',
  'Simplilearn',
  'FutureLearn',
  'ALX Africa',
  'Utiva',
  'AltSchool Africa',
  'Google Career Certificates',
  'AWS Training',
  'Other',
];

export default function AppHelp() {
  const [courseTitle, setCourseTitle] = useState("");
  const [platform, setPlatform] = useState("");
  const [isCustomPlatform, setIsCustomPlatform] = useState(false);
  const [link, setLink] = useState("");
  const [price, setPrice] = useState("");
  const [duration, setDuration] = useState("");
  const [priceUnit, setPriceUnit] = useState("NGN");
  const [durationUnit, setDurationUnit] = useState("months");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [motivation, setMotivation] = useState("");
  const [social, setSocial] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  const [isPublic, setIsPublic] = useState(true);
  const [privateEmails, setPrivateEmails] = useState([""]);
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [userRole, setUserRole] = useState(() => localStorage.getItem("motivar-user-role"));
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const role = localStorage.getItem("motivar-user-role");
    setUserRole(role);
    if (role === "sponsor") {
      navigate("/restricted");
    }
  }, [navigate]);

  useEffect(() => {
    const prefillCourse = location.state?.course;
    if (!prefillCourse) return;
    if (prefillCourse.courseTitle) setCourseTitle(prefillCourse.courseTitle);
    if (prefillCourse.platform) {
      setPlatform(prefillCourse.platform);
      if (!PLATFORM_OPTIONS.includes(prefillCourse.platform)) {
        setIsCustomPlatform(true);
      }
    }
    if (prefillCourse.link) setLink(prefillCourse.link);
    if (prefillCourse.price) setPrice(String(prefillCourse.price));
    if (prefillCourse.priceUnit) setPriceUnit(prefillCourse.priceUnit);
  }, [location.state]);

  // Autofill social link & email from Learner Profile if available
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const res = await axiosInstance.get('/dashboard');
        const d = res.data;

        if (d.userDetails?.email && !email) {
          setEmail(d.userDetails.email);
        }

        const sp = d.socialProfiles || {};
        const firstSocial = sp.linkedin || sp.portfolio || sp.twitter || sp.github || '';
        if (firstSocial && !social) {
          setSocial(firstSocial);
        }
      } catch (err) {
        // Silently ignore errors
      }
    };
    fetchUserProfile();
  }, []);

  const handleAddEmailField = () => {
    setPrivateEmails([...privateEmails, ""]);
  };

  const handleRemoveEmailField = (index) => {
    if (privateEmails.length === 1) return;
    setPrivateEmails(privateEmails.filter((_, i) => i !== index));
  };

  const handleEmailChange = (index, value) => {
    const updatedEmails = [...privateEmails];
    updatedEmails[index] = value;
    setPrivateEmails(updatedEmails);
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);
    const payload = {
      email,
      link,
      course: {
        price: Number(price),
        priceUnit,
        courseTitle,
        duration: Number(duration),
        durationUnit,
        platform,
      },
      motivation,
      account: {
        email,
        password,
      },
      socials: social,
      isPrivate,
      isPublic,
      recipientEmails: isPrivate ? privateEmails.filter(e => e.trim()) : [],
    };

    try {
      const response = await GeneralDataServices.RequestHelp(payload);
      if (response) {
        setLoading(false);
        toast.success(response.data?.message || "Sponsorship request submitted!");
        setIsSubmitted(true);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message || "Submission failed. Please try again.");
    }
  };

  if (userRole === "sponsor") {
    return null;
  }

  const userFirstName = localStorage.getItem("motivar-user-fname") || "Learner";

  const isFormValid =
    courseTitle.trim() &&
    platform.trim() &&
    link.trim() &&
    price.trim() &&
    duration.trim() &&
    email.trim() &&
    password.trim() &&
    motivation.trim() &&
    social.trim() &&
    (!isPrivate || privateEmails.some((e) => e.trim() !== ""));

  // ── Success Celebration Screen ─────────────────────────────────────────────
  if (isSubmitted) {
    return (
      <div style={{ minHeight: "100vh", backgroundColor: "var(--bg-light, #f8fafc)", display: "flex", flexDirection: "column" }}>
        <header>
          <Navbar expand="lg" style={{ backgroundColor: "#ffffff", borderBottom: "1px solid var(--border-color, #e2e8f0)", padding: "1rem 0" }}>
            <Container className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center gap-3">
                <Link to="/dashboard" className="d-flex align-items-center text-decoration-none" title="Back to Dashboard" style={{ color: "var(--text-primary, #0f172a)" }}>
                  <FiArrowLeft size={24} />
                </Link>
                <span style={{ fontWeight: 700, fontSize: "1.25rem", color: "var(--text-primary, #0f172a)" }}>
                  Request for help
                </span>
              </div>
              <Image src={Logo} style={{ maxHeight: "32px" }} alt="Motivar" />
            </Container>
          </Navbar>
        </header>

        <Container style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "3rem 1rem" }}>
          <Card className="shadow-lg text-center p-4 p-md-5" style={{ maxWidth: "550px", width: "100%", borderRadius: "20px", border: "none" }}>
            <div className="mb-4">
              <img src={SuccessTick} alt="Success" style={{ width: "110px", height: "110px" }} />
            </div>
            <h2 style={{ fontWeight: 800, color: "var(--text-primary, #0f172a)", marginBottom: "0.5rem" }}>
              Request Submitted!
            </h2>
            <p style={{ color: "var(--text-secondary, #64748b)", fontSize: "0.95rem", marginBottom: "1.75rem", lineHeight: 1.6 }}>
              Thank you, <strong>{userFirstName}</strong>. Your course sponsorship request for <strong>"{courseTitle}"</strong> has been received and is now being matched with sponsors.
            </p>
            <div className="d-flex flex-column gap-2">
              <Button
                onClick={() => navigate("/dashboard")}
                style={{
                  backgroundColor: "var(--primary-color, #00AA87)",
                  borderColor: "var(--primary-color, #00AA87)",
                  fontWeight: 600,
                  fontSize: "1rem",
                  padding: "0.75rem 1.5rem",
                  borderRadius: "50px",
                }}
              >
                Return to Dashboard
              </Button>
              <Button
                variant="outline-secondary"
                onClick={() => { setIsSubmitted(false); setCourseTitle(""); setLink(""); }}
                style={{
                  fontWeight: 500,
                  fontSize: "0.9rem",
                  borderRadius: "50px",
                }}
              >
                Submit Another Request
              </Button>
            </div>
          </Card>
        </Container>
        <AppFooter />
      </div>
    );
  }

  // ── Main Request Form View ──────────────────────────────────────────────────
  return (
    <div style={{ minHeight: "100vh", backgroundColor: "var(--bg-light, #f8fafc)", display: "flex", flexDirection: "column" }}>
      <header>
        <Navbar expand="lg" style={{ backgroundColor: "#ffffff", borderBottom: "1px solid var(--border-color, #e2e8f0)", padding: "0.9rem 0" }}>
          <Container className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3">
              <Link to="/dashboard" className="d-flex align-items-center text-decoration-none" title="Back to Dashboard" style={{ color: "var(--text-primary, #0f172a)" }}>
                <FiArrowLeft size={24} />
              </Link>
              <span style={{ fontWeight: 700, fontSize: "1.25rem", color: "var(--text-primary, #0f172a)" }}>
                Request for help
              </span>
            </div>
            <Image src={Logo} style={{ maxHeight: "32px" }} alt="Motivar" />
          </Container>
        </Navbar>
      </header>

      <main style={{ flex: 1, padding: "2rem 0 4rem" }}>
        <Container>
          <Row className="g-4 align-items-start">
            {/* Left Form Column */}
            <Col lg={7} md={6}>
              <div className="mb-4 text-center text-md-start">
                <h3 style={{ fontWeight: 800, color: "var(--text-primary, #0f172a)", marginBottom: "0.4rem" }}>
                  Hey {userFirstName}, tell us about your course
                </h3>
                <p style={{ color: "var(--text-secondary, #64748b)", fontSize: "0.92rem" }}>
                  Fill in the details below to request course funding from verified sponsors.
                </p>
              </div>

              <Form onSubmit={handleSubmit}>
                {/* 1. Course Information Card */}
                <Card className="shadow-sm mb-4" style={{ borderRadius: "16px", border: "1px solid var(--border-color, #e2e8f0)", overflow: "hidden" }}>
                  <Card.Header style={{ backgroundColor: "#ffffff", borderBottom: "1px solid #f1f5f9", padding: "1rem 1.25rem", fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div className="d-flex align-items-center gap-2">
                      <FiBookOpen style={{ color: "var(--primary-color, #00AA87)" }} />
                      <span>1. Course Information</span>
                    </div>
                    <span style={{ backgroundColor: "rgba(255, 122, 89, 0.12)", color: "var(--secondary-color, #FF7A59)", fontSize: "0.72rem", padding: "0.2rem 0.6rem", borderRadius: "50px", fontWeight: 700 }}>
                      STEP 1
                    </span>
                  </Card.Header>
                  <Card.Body className="p-3 p-md-4">
                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontWeight: 600, fontSize: "0.88rem" }}>Course Title *</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="e.g. Digital Marketing for Beginners"
                        value={courseTitle}
                        onChange={(e) => setCourseTitle(e.target.value)}
                        style={{ borderRadius: "10px", borderColor: "var(--border-color, #ced4da)", padding: "0.65rem 0.9rem" }}
                      />
                    </Form.Group>

                    <Row className="g-3 mb-3">
                      <Col md={6}>
                        <Form.Label style={{ fontWeight: 600, fontSize: "0.88rem" }}>Platform *</Form.Label>
                        <Form.Select
                          value={isCustomPlatform ? 'Other' : (PLATFORM_OPTIONS.includes(platform) ? platform : (platform ? 'Other' : ''))}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === 'Other') {
                              setIsCustomPlatform(true);
                              setPlatform('');
                            } else {
                              setIsCustomPlatform(false);
                              setPlatform(val);
                            }
                          }}
                          style={{ borderRadius: "10px", borderColor: "var(--border-color, #ced4da)", padding: "0.65rem 0.9rem", fontWeight: 500 }}
                        >
                          <option value="">Select Platform...</option>
                          {PLATFORM_OPTIONS.map(p => (
                            <option key={p} value={p}>{p}</option>
                          ))}
                        </Form.Select>

                        {(isCustomPlatform || (platform && !PLATFORM_OPTIONS.includes(platform))) && (
                          <Form.Control
                            type="text"
                            placeholder="Type custom platform name..."
                            value={platform}
                            onChange={(e) => setPlatform(e.target.value)}
                            className="mt-2"
                            style={{ borderRadius: "10px", borderColor: "var(--border-color, #ced4da)", padding: "0.55rem 0.9rem", fontSize: "0.88rem" }}
                          />
                        )}
                      </Col>
                      <Col md={6}>
                        <Form.Label style={{ fontWeight: 600, fontSize: "0.88rem" }}>Course Web Link *</Form.Label>
                        <Form.Control
                          type="url"
                          placeholder="https://example.com/course"
                          value={link}
                          onChange={(e) => setLink(e.target.value)}
                          style={{ borderRadius: "10px", borderColor: "var(--border-color, #ced4da)", padding: "0.65rem 0.9rem" }}
                        />
                      </Col>
                    </Row>

                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Label style={{ fontWeight: 600, fontSize: "0.88rem" }}>Course Price *</Form.Label>
                        <div className="d-flex">
                          <Form.Select
                            value={priceUnit}
                            onChange={(e) => setPriceUnit(e.target.value)}
                            style={{ borderRadius: "10px 0 0 10px", borderColor: "var(--border-color, #ced4da)", width: "90px", fontWeight: 600 }}
                          >
                            <option value="NGN">NGN</option>
                            <option value="USD">USD</option>
                            <option value="GBP">GBP</option>
                            <option value="EUR">EUR</option>
                          </Form.Select>
                          <Form.Control
                            type="number"
                            placeholder="e.g. 15000"
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                            style={{ borderRadius: "0 10px 10px 0", borderColor: "var(--border-color, #ced4da)", flex: 1, padding: "0.65rem 0.9rem" }}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <Form.Label style={{ fontWeight: 600, fontSize: "0.88rem" }}>Estimated Duration *</Form.Label>
                        <div className="d-flex">
                          <Form.Control
                            type="number"
                            placeholder="e.g. 3"
                            value={duration}
                            onChange={(e) => setDuration(e.target.value)}
                            style={{ borderRadius: "10px 0 0 10px", borderColor: "var(--border-color, #ced4da)", flex: 1, padding: "0.65rem 0.9rem" }}
                          />
                          <Form.Select
                            value={durationUnit}
                            onChange={(e) => setDurationUnit(e.target.value)}
                            style={{ borderRadius: "0 10px 10px 0", borderColor: "var(--border-color, #ced4da)", width: "110px", fontWeight: 600 }}
                          >
                            <option value="months">Months</option>
                            <option value="weeks">Weeks</option>
                          </Form.Select>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                {/* 2. Platform Account Details Card */}
                <Card className="shadow-sm mb-4" style={{ borderRadius: "16px", border: "1px solid var(--border-color, #e2e8f0)", overflow: "hidden" }}>
                  <Card.Header style={{ backgroundColor: "#ffffff", borderBottom: "1px solid #f1f5f9", padding: "1rem 1.25rem", fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div className="d-flex align-items-center gap-2">
                      <FiLock style={{ color: "var(--primary-color, #00AA87)" }} />
                      <span>2. Platform Credentials</span>
                    </div>
                    <span style={{ backgroundColor: "rgba(255, 122, 89, 0.12)", color: "var(--secondary-color, #FF7A59)", fontSize: "0.72rem", padding: "0.2rem 0.6rem", borderRadius: "50px", fontWeight: 700 }}>
                      STEP 2
                    </span>
                  </Card.Header>
                  <Card.Body className="p-3 p-md-4">
                    <p style={{ fontSize: "0.82rem", color: "var(--text-secondary, #64748b)", marginBottom: "1rem" }}>
                      Sponsors require access to disburse funds directly into your course account.
                    </p>
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Label style={{ fontWeight: 600, fontSize: "0.88rem" }}>Platform Email *</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Your course account email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          style={{ borderRadius: "10px", borderColor: "var(--border-color, #ced4da)", padding: "0.65rem 0.9rem" }}
                        />
                      </Col>
                      <Col md={6}>
                        <Form.Label style={{ fontWeight: 600, fontSize: "0.88rem" }}>Platform Password *</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="e.g. MotivarPay4JohnDoe"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          style={{ borderRadius: "10px", borderColor: "var(--border-color, #ced4da)", padding: "0.65rem 0.9rem" }}
                        />
                        <span style={{ fontSize: "0.75rem", color: "var(--text-secondary, #64748b)", fontStyle: "italic", display: "block", marginTop: "4px" }}>
                          Temporarily set your platform password to the format: <strong style={{ color: "var(--primary-color, #00AA87)", fontStyle: "normal" }}>MotivarPay4(Fullname)</strong> (e.g. <em>MotivarPay4JohnDoe</em>)
                        </span>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                {/* 3. Motivation & Socials Card */}
                <Card className="shadow-sm mb-4" style={{ borderRadius: "16px", border: "1px solid var(--border-color, #e2e8f0)", overflow: "hidden" }}>
                  <Card.Header style={{ backgroundColor: "#ffffff", borderBottom: "1px solid #f1f5f9", padding: "1rem 1.25rem", fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div className="d-flex align-items-center gap-2">
                      <FiGlobe style={{ color: "var(--primary-color, #00AA87)" }} />
                      <span>3. Motivation & Verification</span>
                    </div>
                    <span style={{ backgroundColor: "rgba(255, 122, 89, 0.12)", color: "var(--secondary-color, #FF7A59)", fontSize: "0.72rem", padding: "0.2rem 0.6rem", borderRadius: "50px", fontWeight: 700 }}>
                      STEP 3
                    </span>
                  </Card.Header>
                  <Card.Body className="p-3 p-md-4">
                    <Form.Group className="mb-3">
                      <Form.Label style={{ fontWeight: 600, fontSize: "0.88rem" }}>Why do you need this course? *</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Explain how this course helps your career goals (max 50 words)..."
                        value={motivation}
                        onChange={(e) => setMotivation(e.target.value)}
                        style={{ borderRadius: "10px", borderColor: "var(--border-color, #ced4da)", padding: "0.65rem 0.9rem" }}
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label style={{ fontWeight: 600, fontSize: "0.88rem" }}>Social Media Profile Link *</Form.Label>
                      <Form.Control
                        type="url"
                        placeholder="e.g. https://linkedin.com/in/username"
                        value={social}
                        onChange={(e) => setSocial(e.target.value)}
                        style={{ borderRadius: "10px", borderColor: "var(--border-color, #ced4da)", padding: "0.65rem 0.9rem" }}
                      />
                    </Form.Group>
                  </Card.Body>
                </Card>

                {/* 4. Request Visibility & Private Emails Card */}
                <Card className="shadow-sm mb-4" style={{ borderRadius: "16px", border: "1px solid var(--border-color, #e2e8f0)", overflow: "hidden" }}>
                  <Card.Header style={{ backgroundColor: "#ffffff", borderBottom: "1px solid #f1f5f9", padding: "1rem 1.25rem", fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div className="d-flex align-items-center gap-2">
                      <FiShield style={{ color: "var(--primary-color, #00AA87)" }} />
                      <span>4. Visibility & Privacy</span>
                    </div>
                    <span style={{ backgroundColor: "rgba(255, 122, 89, 0.12)", color: "var(--secondary-color, #FF7A59)", fontSize: "0.72rem", padding: "0.2rem 0.6rem", borderRadius: "50px", fontWeight: 700 }}>
                      STEP 4
                    </span>
                  </Card.Header>
                  <Card.Body className="p-3 p-md-4">
                    <div className="d-flex flex-column gap-2 mb-3">
                      <Form.Check
                        type="checkbox"
                        id="check-public"
                        label="Make this request public (Visible to all sponsors)"
                        checked={isPublic}
                        onChange={(e) => setIsPublic(e.target.checked)}
                        style={{ fontWeight: 500, fontSize: "0.9rem" }}
                      />
                      <Form.Check
                        type="checkbox"
                        id="check-private"
                        label="Send request privately to specific emails"
                        checked={isPrivate}
                        onChange={(e) => setIsPrivate(e.target.checked)}
                        style={{ fontWeight: 500, fontSize: "0.9rem" }}
                      />
                    </div>

                    {isPrivate && (
                      <div className="p-3 mt-2 rounded" style={{ backgroundColor: "var(--bg-light, #f1f5f9)", border: "1px solid var(--border-color, #cbd5e1)" }}>
                        <h6 style={{ fontWeight: 700, fontSize: "0.85rem", marginBottom: "0.5rem" }}>
                          Recipient Sponsor Emails
                        </h6>
                        {privateEmails.map((email, idx) => (
                          <div key={idx} className="d-flex align-items-center gap-2 mb-2">
                            <Form.Control
                              type="email"
                              placeholder="sponsor@example.com"
                              value={email}
                              onChange={(e) => handleEmailChange(idx, e.target.value)}
                              style={{ borderRadius: "8px", borderColor: "var(--border-color, #ced4da)", fontSize: "0.85rem" }}
                            />
                            {privateEmails.length > 1 && (
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => handleRemoveEmailField(idx)}
                                style={{ borderRadius: "8px", padding: "0.35rem 0.6rem" }}
                              >
                                <FiTrash2 size="0.85em" />
                              </Button>
                            )}
                          </div>
                        ))}
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={handleAddEmailField}
                          style={{ fontSize: "0.78rem", borderRadius: "50px", fontWeight: 600, marginTop: "4px" }}
                        >
                          <FiPlus size="0.9em" className="me-1" /> Add Recipient
                        </Button>
                      </div>
                    )}
                  </Card.Body>
                </Card>

                {/* Submit Action Button */}
                <div className="d-flex justify-content-end mt-4">
                  <Button
                    type="submit"
                    className="shadow-sm"
                    style={{
                      backgroundColor: "var(--primary-color, #00AA87)",
                      borderColor: "var(--primary-color, #00AA87)",
                      border: "none",
                      fontWeight: 600,
                      fontSize: "0.95rem",
                      padding: "0.65rem 1.8rem",
                      borderRadius: "50px",
                      color: "#ffffff",
                    }}
                    disabled={loading || !isFormValid}
                  >
                    {loading ? (
                      <><Spinner animation="border" size="sm" className="me-2" /> Submitting...</>
                    ) : (
                      <><FiSend className="me-2" /> Submit Request</>
                    )}
                  </Button>
                </div>
              </Form>
            </Col>

            {/* Right Showcase Side Column - PROMINENTLY VISIBLE ACROSS DESKTOP & TABLETS */}
            <Col lg={5} md={6}>
              <div className="sticky-top" style={{ top: "2rem" }}>
                <Card className="border-0 shadow overflow-hidden mb-4" style={{ borderRadius: "20px" }}>
                  <div style={{ position: "relative", overflow: "hidden", height: "320px" }}>
                    <Image
                      src={Image_help}
                      alt="Course Sponsorship"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center 15%",
                        display: "block",
                      }}
                    />
                  </div>

                  <Card.Body className="p-4">
                    <h5 style={{ fontWeight: 700, color: "var(--text-primary, #0f172a)", marginBottom: "1rem" }}>
                      How Sponsorship Works
                    </h5>
                    <ul className="list-unstyled d-flex flex-column gap-3 mb-0" style={{ fontSize: "0.9rem", color: "var(--text-secondary, #475569)" }}>
                      <li className="d-flex align-items-start gap-2">
                        <FiCheckCircle size="1.15em" style={{ color: "var(--secondary-color, #FF7A59)", flexShrink: 0, marginTop: "2px" }} />
                        <span><strong style={{ color: "var(--text-primary, #0f172a)" }}>Direct Funding:</strong> Verified sponsors pay your course fee directly into your learning account.</span>
                      </li>
                      <li className="d-flex align-items-start gap-2">
                        <FiCheckCircle size="1.15em" style={{ color: "var(--primary-color, #00AA87)", flexShrink: 0, marginTop: "2px" }} />
                        <span><strong style={{ color: "var(--text-primary, #0f172a)" }}>Fast Match:</strong> Public requests are broadcasted to our network of corporate sponsors & mentors.</span>
                      </li>
                      <li className="d-flex align-items-start gap-2">
                        <FiCheckCircle size="1.15em" style={{ color: "var(--secondary-color, #FF7A59)", flexShrink: 0, marginTop: "2px" }} />
                        <span><strong style={{ color: "var(--text-primary, #0f172a)" }}>Privacy Control:</strong> Choose between public listing or sending private request links directly to your network.</span>
                      </li>
                    </ul>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </main>

      <AppFooter />
    </div>
  );
}
